import { on, select, addClass, removeClass, setAttribute, getAttribute } from 'helpers/dom'

const selectors = {
  TOGGLE_SELECTOR: '.js-toggle-dropdown',
  DROPDOWN_SELECTOR: '.js-dropdown',
  FOOTER_BOTTOM_SELECTOR: '.js-footer-bottom',
  ACTIVE_CLASS: 'dropdown-is-active',
  TIMEOUT: 301
}

class CountryDropdown extends HTMLElement {
  constructor () {
    super()

    this.toggleEl = select(selectors.TOGGLE_SELECTOR, this)
    this.dropdownEl = select(selectors.DROPDOWN_SELECTOR, this)
    this.footerBottom = select(selectors.FOOTER_BOTTOM_SELECTOR)
  }

  connectedCallback () {
    if (this.toggleEl) {
      on('click', this.toggleDropdown.bind(this), this.toggleEl)
    }

    on('keyup', this.handleKeyUp.bind(this), window)
    on('focusin', this.handleFocusIn.bind(this), window)

    if (this.dropdownEl && this.toggleEl) {
      on('click', (event) => {
        const isExpanded = getAttribute('aria-expanded', this.toggleEl) === 'true'

        if (isExpanded && !this.dropdownEl.contains(event.target) && !this.toggleEl.contains(event.target)) {
          this.hideDropdown()
        }
      }, document)
    }
  }

  handleKeyUp (event) {
    if (event.key === 'Escape' && getAttribute('aria-expanded', this.toggleEl) === 'true') {
      this.hideDropdown(true)
    }
  }

  handleFocusIn (event) {
    if (!this.contains(event.target)) {
      this.hideDropdown()
    }
  }

  toggleDropdown () {
    const isExpanded = getAttribute('aria-expanded', this.toggleEl) === 'true'

    if (isExpanded) {
      this.hideDropdown(false)
    } else {
      this.showDropdown()
    }
  }

  showDropdown () {
    setAttribute('aria-expanded', 'true', this.toggleEl)
    addClass(selectors.ACTIVE_CLASS, this)

    if (document.body.offsetWidth < 1024) {
      this.footerBottom.style.paddingBottom = '48px'
    }
  }

  hideDropdown (shouldFocus = false) {
    setAttribute('aria-expanded', 'false', this.toggleEl)
    removeClass(selectors.ACTIVE_CLASS, this)

    if (shouldFocus) {
      setTimeout(() => {
        this.toggleEl.focus()
      }, selectors.TIMEOUT)
    }

    if (document.body.offsetWidth < 1024) {
      this.footerBottom.style.paddingBottom = '0'
    }
  }
}

if (!customElements.get('country-dropdown')) {
  customElements.define('country-dropdown', CountryDropdown)
}
